export default "https://assets.egbcdn.net/assets/packs/_/images/app/android/android-en-4-cd5301f3649578310532b7e6b21d58dd.png";